import { Injectable, inject } from '@angular/core';
import { VwApiRequestsService } from 'vwappservices';

@Injectable({ providedIn: 'root' })
export class MachinesApiService {
  private api = inject(VwApiRequestsService);

  list() {
    return this.api.getAPICall('/machines');
  }

  get(id: string) {
    return this.api.getAPICall(`/machines/${id}`);
  }

  create(payload: { name: string; nameMr?: string; code: string; location?: string; notes?: string; machineTypeId?: string | null }) {
    return this.api.postAPICall('/machines', payload);
  }

  update(id: string, payload: Record<string, any>) {
    return this.api.postAPICall(`/machines/${id}`, payload);
  }

  delete(id: string) {
    return this.api.postAPICall(`/machines/${id}/delete`, {});
  }
}
